import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AdministartionService } from 'src/app/service/administartion.service';

@Component({
  selector: 'app-edit-lp-route-system',
  templateUrl: './edit-lp-route-system.component.html',
  styleUrls: ['./edit-lp-route-system.component.scss']
})
export class EditLpRouteSystemComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EditLpRouteSystemComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private fb: FormBuilder, private adminService: AdministartionService, private ngxUiLoaderService: NgxUiLoaderService) { }
  header: any
  eventType: any
  disableLP: boolean = false
  showLP: boolean = true
  errorMessage = ''
  fullData: any;
  submitted: boolean = false;
  reference: any;

  addEditForm = this.fb.group({
    lp: [''],
    MROSTrailer: ['', Validators.required],
    shortDescription: [''],
    description: [''],
    palletCode: [''],
    
  })
  ngOnInit(): void {
    this.header = this.dataStore.header
    this.fullData = this.dataStore.fullData
    console.log(this.dataStore.fullData,this.dataStore.editdatas,this.dataStore.selectedData)
    this.disableLP = true
    this.showLP = false
    this.addEditForm.controls.lp.setValue(this.dataStore.editdatas.lpId);
    this.addEditForm.controls.MROSTrailer.setValue(this.dataStore.editdatas.MROSTrailer);
    this.addEditForm.controls.shortDescription.setValue(this.dataStore.editdatas.shortDescription);
    this.addEditForm.controls.description.setValue(this.dataStore.editdatas.description);
    this.addEditForm.controls.palletCode.setValue(this.dataStore.editdatas.palletCode);
    this.createReference(this.addEditForm.value)
    }
  
    createReference(obj: any) {
      this.reference = Object.assign({}, obj);
    }  
    submitForm() {
    this.errorMessage = ''
    this.submitted = true;
    this.editLPRouteSystem()

  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  
  editLPRouteSystem(){
    if (this.addEditForm.controls.MROSTrailer.value?.trim() == "") {
      return;
    }
    for (let data of this.fullData) {
      console.log(this.addEditForm.controls.MROSTrailer.value,data['MROSTrailer'])
        if (this.addEditForm.controls.MROSTrailer.value === data['MROSTrailer'] &&  this.addEditForm.controls.lp.value != data['lpId']
        ) {
          this.errorMessage = `Run should be Unique (${this.addEditForm.controls.MROSTrailer.value})`
          return
        }
    }
    let bodyArray: any = []
    let addEditForm: any = this.addEditForm.value
    for (let prop in this.reference) {
      if (this.reference[prop] != addEditForm[prop]) {
        let obj: any = {}
        obj['id'] = this.dataStore.editdatas[prop+'ID'];
        obj['value'] = addEditForm[prop];
        bodyArray.push(obj)
      }
    }
    if (!bodyArray.length) {
      this.ngxUiLoaderService.stop()
      this.errorMessage = 'Please Change any field'
      return
    }
    else {
      this.ngxUiLoaderService.start()

      let body = {
        "type": 'routeSystem',
        "configCells": bodyArray
      }
      this.adminService.updateAddlnLane(body).subscribe({
        next: (res) => {
          console.log(res)
          if (res.status == 'SUCCESS') {
            this.dialogRef.close(
              {
                event: 'SaveEvent',
                eventData: this.addEditForm
              }
            );
          }
          else {
            this.dialogRef.close(
              {
                event: 'failure',
                eventData: this.addEditForm,
                message: res?.status?.status
              }
            );
          }


        },
        error: (err: any) => {
          this.dialogRef.close(
            {
              event: 'failure',
              eventData: this.addEditForm,
              message: err
            }
          );
        }
      })
    }
  }

  validateRun(event: any) {
    return new RegExp('^[0-9,a-z,A-Z]$').test(event.key);
  }

  updateValues(event: any) {
    const runControl = this.addEditForm.get('MROSTrailer');
    if (runControl) {
      let runValue = runControl.value;
      runValue = runValue != null ? runValue.toUpperCase() : runValue;
      runControl.setValue(runValue);
      this.addEditForm.controls.shortDescription.setValue(this.dataStore.selectedData.routeSystem + "-" + runValue);
      this.addEditForm.controls.description.setValue(this.dataStore.selectedData.routeSystem + "-" + runValue + "-" + this.dataStore.editdatas.lpId);
    }
  }
  }

